<template>
	<div v-if="layout.dataset" class="w-full h-full text-gray-900 labelingBox" style="z-index: 9999999; background-color: #a0aec0;">

		<!-- MAIN -->
		<div class="grid grid-cols-12 h-full">
			
			<!-- COLUMNA IMÁGENES -->
			<div id="imagesColumn" class="col-span-12 sm:col-span-7 lg:col-span-9 xxl:col-span-10 flex flex-col h-full" 
				:style="`background-image: url(${require(`@/assets/images/rosepetal/icon/back-labeling.png`)}); background-position: center; background-size: cover; background-repeat: no-repeat; height: 100vh;`">
				
				<!-- BARRA DE FILTROS -->
				<div id="rpFiltersLabeling" class="h-13 bg-gray-50 border-b border-gray-400 px-4 py-2 flex flex-row items-center gap-4 overflow-x-auto" style="scrollbar-width: none; -ms-overflow-style: none;">
					
					<!-- LOGO -->
					<div class="flex-shrink-0">
						<img style="height: 32px; width: 32px;" :src="require(`@/assets/images/rosepetal/icon/logoLoading.png`)" />
					</div>

					<template v-if="!layout.loading">

						<!-- PROPERTIES DROPDOWN -->
						<div class="dropdown flex">

							<div class="dropdown-toggle image-fit flex items-center text-center mr-4" role="button" aria-expanded="true" style="margin-top: 0;">
								<MoreVerticalIcon class="w-4 h-4" />
								<span class="text-sm font-medium text-gray-700 whitespace-nowrap">Properties</span>
							</div>

							<div class="dropdown-menu rpLabelingTopMenu">
								<div class="dropdown-menu__content box flex bg-gray-50 border border-gray-400">
									
									<div class="form-check p-2 flex">
										<input id="mediaName" type="checkbox" :checked="layout.optImages.mediaName" class="form-check-input bg-white" @change="layout.optImages.mediaName = !layout.optImages.mediaName"  />
										<div class="text-sm px-2">{{ $t('Name') }}</div>
									</div>

									<div v-if="layout.dataset.type=='MULTICLASS' || layout.dataset.type=='MULTILABEL'" class="form-check p-2 flex">
										<input id="mediaMask" type="checkbox" :checked="layout.optImages.mediaMask" class="form-check-input bg-white" @change="layout.optImages.mediaMask = !layout.optImages.mediaMask"  />
										<div class="text-sm px-2">{{ $t('Mask') }}</div>
									</div>

									<div v-if="layout.dataset.type=='imageObjectDetection'" class="form-check p-2 flex">
										<input id="mediaBounding" type="checkbox" :checked="layout.optImages.mediaBounding" class="form-check-input bg-white" @change="layout.optImages.mediaBounding = !layout.optImages.mediaBounding"  />
										<div class="text-sm px-2">{{ $t('Tags') }}</div>
									</div>

									<div class="form-check p-2 flex">
										<input id="mediaSet" type="checkbox" :checked="layout.optImages.mediaSet" class="form-check-input bg-white" @change="layout.optImages.mediaSet = !layout.optImages.mediaSet"  />
										<div class="text-sm px-2">{{ $t('Set') }}</div>
									</div>

									<div class="form-check p-2 flex">
										<input id="mediaDate" type="checkbox" :checked="layout.optImages.mediaDate" class="form-check-input bg-white" @change="layout.optImages.mediaDate = !layout.optImages.mediaDate"  />
										<div class="text-sm px-2">{{ $t('Date') }}</div>
									</div>

								</div>
							</div>

						</div>

						<!-- SELECTOR ORDER -->
						<div class="flex items-center gap-2 border-l pl-4">
							<span v-if="!showResponsive" class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ $t('Order') }}:</span>
							<select class="labeling-select" v-model="layout.optImages.order" >
								<option value="date">{{$t('Created')}}</option>
								<option value="updatedAt">{{$t('Updated')}}</option>
							</select>
							<select class="labeling-select" v-model="layout.optImages.direction" >
								<option value="asc">{{$t('Asc')}}</option>
								<option value="desc">{{$t('Desc')}}</option>
							</select>
						</div>

						<!-- SELECTOR PERPAGE -->
						<div class="flex items-center gap-2 border-l pl-4">
							<span v-if="!showResponsive" class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ $t('Per page') }}:</span>
							<select class="labeling-select" v-model="layout.optImages.perPage" >
								<option v-bind:value="12">12</option>
								<option v-bind:value="50">50</option>
								<option v-bind:value="125">125</option>
								<option v-bind:value="250">250</option>
							</select>
						</div>

						<!-- NAME FILTER -->
						<div class="flex items-center gap-2 border-l pl-4">
							<input 
								type="text" 
								class="w-60 form-input p-1 pl-3 cursor-text bg-white border rounded-md" 
								v-model="layout.optImages.name" 
								@input="filterImages()" 
								placeholder="Filter by name..."
							/>
						</div>

						<!-- PAGINATION -->
						<div class="flex items-center ml-auto">

							<ul v-if="layout.dataset?.images?.pagination" class="pagination flex items-center gap-1">

								<li v-if="layout.dataset.images.pagination.prev && (layout.dataset.images.pagination.currentPage + 1) > 2">
									<button class="pagination-btn" @click="layout.optImages.action='firstPage'; reload()">
										<ChevronsLeftIcon class="w-5 h-5" />
									</button>
								</li>
								
								<li v-if="layout.dataset.images.pagination.prev">
									<button class="pagination-btn" @click="layout.optImages.action='previousPage'; reload()">
										<ChevronLeftIcon class="w-5 h-5" />
									</button>
								</li>

								<li>
									<select class="pagination-select" 
										v-model="layout.dataset.images.pagination.currentPage" 
										@change="layout.optImages.action = 'selectedPage'; reload()">
										<option v-for="n in (layout.dataset.images.pagination.pages ?? 0)" :key="n" :value="n - 1">
											{{ n }}
										</option>
									</select>
								</li>

								<li v-if="layout.dataset.images.pagination.next">
									<button class="pagination-btn" @click="layout.optImages.action='nextPage'; reload()">
										<ChevronRightIcon class="w-5 h-5" />
									</button>
								</li>

								<li v-if="layout.dataset.images.pagination.next && (layout.dataset.images.pagination.currentPage + 1) < (layout.dataset.images.pagination.pages - 1)">
									<button class="pagination-btn" @click="layout.optImages.action='lastPage'; reload()">
										<ChevronsRightIcon class="w-5 h-5" />
									</button>
								</li>

							</ul>

						</div>

					</template>

				</div>
				
				<!-- SELECTION AND ACTIONS -->
				<div v-if="!completeDataset && countCheck() && !layout.loading" id="selectionSection" class="grid grid-cols-12">
					<div class="col-span-12 bg-white">
						<div class="flex items-center rounded px-5 py-1.5 mx-auto bg-transparent">
							
							<!-- SELECT/DESELECT ACTIONS -->
							<div class="flex items-center mr-6">
								<span class="selection-action-link mr-4 cursor-pointer" @click="check()">{{ $t('Select all') }}</span>
								<span class="selection-action-link cursor-pointer" @click="unCheck()">{{ $t('Deselect all') }}</span>
							</div> 

							<!-- MEDIA COUNT -->
							<div class="flex items-center mr-6">
								<span class="text-2xl font-bold text-gray-900 pr-2">{{ countCheck() }}</span>
								<span class="text-sm text-gray-900">{{ $t('media selected') }}</span>
							</div>

							<!-- ACTION BUTTONS -->
							<div class="flex items-center gap-2">
                                <button v-if="layout.dataset.type == 'MULTICLASS' || layout.dataset.type == 'ANOMALY'" 
                                    class="selection-action-button" 
                                    @click="showAssignTag = true">
                                    {{ $t('Assign tag') }}
                                </button>
                                <button class="selection-action-button" 
                                    @click="modal('modal-change-set')">
                                    {{ $t('Data division') }}
                                </button>
                                <button class="selection-action-button" 
                                    @click="showDownloadDataset = true">
                                    {{ $t('Download') }}
                                </button>
                                <button class="selection-action-button" 
                                    @click="layout.copy.success = false; layout.move.toDataset = false; modal('modal-move-selected')">
                                    {{ $t('Move') }}
                                </button>
                                <button class="selection-action-button" 
                                    @click="layout.copy.success = false; layout.copy.toDataset = false; modal('modal-copy-selected')">
                                    {{ $t('Copy') }}
                                </button>
                                <button class="selection-action-button selection-action-button-danger" 
                                    @click="modal('modal-delete')">
                                    <Trash2Icon class="w-4 h-4" />
                                </button>
                            </div>

						</div>
					</div>
				</div>

				<!-- IMAGES SECTION -->
				<div id="imagesSection" class="h-full flex-grow chat grid grid-cols-12 gap-6 overflow-x-auto overflow-y-auto">
					
					<!-- LISTADO IMAGES -->
					<div v-if="!layout.loading" id="imagesList" class="col-span-12 text-left text-xs w-full h-full">
						
						<!-- IMAGES -->
						<div v-if="layout.dataset?.images?.media && layout.dataset.images.media.length" class="intro-y grid grid-cols-12 gap-4 p-5">
							<div v-for="(image, idx) in layout.dataset.images.media" v-bind:key="image" class="intro-y col-span-2" :class="'sm:col-span-' + layout.optImages.mediaSize + ' md:col-span-' + layout.optImages.mediaSize + ' lg:col-span-' + layout.optImages.mediaSize + ' xxl:col-span-' + layout.optImages.mediaSize">
								<div class="rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer"
									:class="[
										{
											'ring-2': Object.values(selectedImages).includes(image.id),
											'ring-2 ring-purple-400': !Object.values(selectedImages).includes(image.id) && (image.set === 'REVIEW' || isImageLabeled(image)),
											'hover:ring-1 hover:ring-gray-200': !Object.values(selectedImages).includes(image.id) && !(image.set === 'REVIEW' || isImageLabeled(image))
										},
										(image.set === 'REVIEW' || isImageLabeled(image)) ? 'bg-purple-50' : 'bg-white'
									]"
									@click="checkItem(image, $event)" 
									:style="Object.values(selectedImages).includes(image.id) ? '--tw-ring-color: #17356e' : ''">
									
									<div class="px-2 py-1.5 flex items-center justify-between border-b"
										:class="(image.set === 'REVIEW' || isImageLabeled(image)) ? 'bg-purple-100 border-purple-200' : 'bg-white border-gray-100'">
										<div class="flex items-center gap-1.5">
											<span v-if="image.tagName && (layout.dataset.type == 'MULTICLASS' || layout.dataset.type == 'MULTILABEL' || layout.dataset.type == 'ANOMALY') && layout.optImages.mediaLabel" 
												class="py-0.5 px-2 rounded text-xs font-medium text-white"
												:class="!layout.dataset?.tags[image.tagName] ? 'bg-gray-500' : ''"
												:style="layout.dataset?.tags[image.tagName] ? 'background-color: ' + layout.dataset.tags[image.tagName].color : ''" >
												{{ image.tagName == "0" ? layout.dataset.type == 'MULTILABEL' ? 'Anomaly' : 'Unclassified' : layout.dataset.tags[image.tagName].name }}
											</span>
											<AlignLeftIcon v-if="image?.comments" class="w-3.5 h-3.5 text-gray-400" title="Comments" />
										</div>
										<input class="form-check-input border border-gray-300 bg-gray-100 rounded flex-shrink-0 absolute" v-model="selectedImages" :value="image.id" type="checkbox" />
									</div>

									<div class="aspect-square relative cursor-pointer" @click.stop="layout.selectedId = image.id">

										<img v-if="image.img_base64_val || image.imageData?.previewImg" 
											 :src="image.img_base64_val || image.imageData.previewImg"
											 :id="'previewImg_' + image.id"
											 class="absolute inset-0 w-full h-full object-cover"
											 @load="onPreviewLoaded(image)" />
										
										<img v-lazy="image.img_base64_val || image.imageData?.lowResImg" 
											 :id="'lowResImg_' + image.id"
											 class="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-300" 
											 @load="onLowResLoaded(image)"
											 @error="onImageError(image)" />
										
										<canvas :id="'thumbCanvas_' + image.id" class="absolute inset-0 w-full h-full object-cover pointer-events-none" style="z-index: 5;"></canvas>
										
										<div v-if="layout.optImages.mediaSet && (isImageLabeled(image) || image?.set)" class="absolute top-2 left-2 z-10 flex gap-1">
											<span v-if="isImageLabeled(image)" class="py-0.5 px-2 rounded text-xs font-medium shadow bg-purple-600 text-white">
												LABELED
											</span>
											<span v-if="image?.set" class="py-0.5 px-2 rounded text-xs font-medium shadow"
												:class="{
													'bg-purple-600 text-white': image.set === 'REVIEW',
													'bg-gray-300 text-gray-600': image.set !== 'REVIEW'
												}">
												{{ image.set }}
											</span>
										</div>
									</div>

									<div class="pl-2 pr-1 py-1.5"
										:class="(image.set === 'REVIEW' || isImageLabeled(image)) ? 'bg-purple-100' : 'bg-white'">
										<div class="flex items-center justify-between text-xs">
											<div class="truncate flex-1 pr-2">
												<div v-if="image?.name && layout.optImages.mediaName" class="text-sm font-medium text-gray-900 truncate mb-0.5">{{ image.name.toString().split('/').pop() }}</div>
												<div v-if="layout.optImages.mediaDate" class="text-gray-500 truncate">
													<span v-if="layout.optImages.order == 'date' && image?.createdDate">{{ image.createdDate }}</span>
													<span v-if="layout.optImages.order == 'updatedAt' && image?.updatedDate">{{ image.updatedDate }}</span>
												</div>
											</div>
											<span class="px-1.5 py-0.5 rounded text-xs font-medium flex-shrink-0 !bg-white !text-gray-600">
												{{ (idx + (layout.dataset.images.pagination.currentPage * layout.optImages.perPage)) + 1 }}
											</span>
										</div>
									</div>
									
								</div>
							</div>
						</div>

						<!-- NO IMAGES -->
						<div v-else class="text-center w-full h-full">
							<div v-if="layout.dataset?.tagStats && layout.dataset?.images?.media" class="p-20 h-full bg-white text-center text-gray-600;"> 
								<div class="flex items-center justify-center w-full bg-white"><img :src="require(`@/assets/images/rosepetal/icon/noResults.jpg`)" /></div>
								<div>{{ $t('No images found for the selected filters') }}.</div>
								<div>{{ $t('Please try adjusting your filter criteria') }}.</div>
							</div>
							<div v-else class="col-span-12 lg:col-span-12 flex flex-grow items-center">
								<div class="flex items-center justify-center w-full h-full bg-white" :style="`background-image: url(${require(`@/assets/images/rosepetal/icon/train7.gif`)}); background-position: top center; background-repeat: no-repeat; height: 100%; height: 100vh;`"></div> 
							</div>
						</div>

					</div>

					<!-- LOADING -->
					<div v-else id="loadingSection" class="col-span-12 flex flex-grow items-center bg-white">
						<div class="flex items-center justify-center w-full h-full"
							:style="`background-image: url(${require(`@/assets/images/rosepetal/icon/train7.gif`)}); background-position: top center; background-repeat: no-repeat;`"></div>
					</div>

				</div>

			</div>

			<!-- COLUMNA STATS -->
			<div id="statsColumn" class="col-span-12 sm:col-span-5 lg:col-span-3 xxl:col-span-2 flex flex-col h-full bg-white border-l border-gray-400" style="overflow-y: auto;">
				
				<!-- BARRA DE EXIT -->
				<div id="barraExit" class="h-12 bg-gray-50 border-b border-gray-400 sticky top-0 z-20 flex">
					
					<button id="BtnLabelingReload" type="button" class="labeling-action-button border-r border-gray-400 flex-1" 
						title="Reload"
						@click="reload(true);">
						<RefreshCwIcon class="labeling-action-icon" />
					</button>

					<button id="BtnLabelingExit" type="button" class="labeling-action-button flex-1" 
						title="Exit"
						data-dismiss="modal" 
						@click="$emit('closeLabeling'); router.push('/datasets/' + props.options.dataset.id)">
						<LogOutIcon class="labeling-action-icon" />
					</button>
					
				</div>

				<!-- STATS SECTION-->
				<div id="statsSection" class="h-full flex-grow rpLabelingMenu overflow-y-auto" style="scrollbar-width: none; -ms-overflow-style: none;">
					<ul class="divide-y divide-gray-200">

						<li id="eMdataset" class="nav selected" @click="labelingMenu('eMdataset')">
							<span class="text-sm text-gray-700">{{ $t('Dataset') }}</span>
							<span class="arrow-icon"></span>
						</li>
						
						<!-- DATASET INFO -->
						<li class="menu-content eMdataset sel">
							<div v-if="layout.dataset?.name" class="font-medium text-sm" >{{ layout.dataset.name }}</div>
							<div v-if="layout.dataset?.typeName" class="font-normal text-gray-600">{{ layout.dataset.typeName }}</div>
							<div v-if="layout.dataset?.description" class="pt-2 mr-5 text-gray-600" >{{ layout.dataset?.description.toString() }}</div>
							<div class="flex justify-center mt-4 gap-2">
								<button v-if="layout.dataset?.name" class="dataset-action-button" type="button" @click="showDownloadDataset = true; completeDataset = true;">
									<DownloadIcon class="w-4 h-4 mr-2" /> <span>{{$t('Dataset')}}</span>
								</button>
								<button v-if="layout.dataset?.name" class="dataset-action-button" type="button" @click="downloadCSV();">
									<DownloadIcon class="w-4 h-4 mr-2" /> <span>{{$t('CSV')}}</span>
								</button>
							</div>
						</li>
						
						<!-- AUTOCLASSIFIER -->
						<template v-if="layout.dataset.type == 'MULTICLASS' || layout.dataset.type == 'ANOMALY'">

							<li id="eMautoclassifier" class="nav selected" @click="labelingMenu('eMautoclassifier')">
								<div class="flex items-center">
									<span class="text-sm text-gray-700">Auto classifier</span>
									
									<button @click.stop="modal('modal-help')" class="ml-2 text-blue-500 hover:text-blue-900 transition-colors">
										<InfoIcon class="w-4 h-4" />
									</button>
								</div>
								<div class="w-3 h-3 rounded-full"
									:class="{
										'bg-gray-400': classifierState === 'inactive',
										'bg-yellow-400 animate-pulse': classifierState === 'activating' || classifierState === 'caching',
										'bg-green-500': classifierState === 'active'
									}">
								</div>
							</li>

							<li class="menu-content eMautoclassifier sel" :class="{'is-loading': isReviewing}">

							<div v-if="hasReviewImages" 
								class="m-2 p-4 bg-gradient-to-br from-amber-50 to-yellow-100 rounded-lg border-2 border-amber-200 shadow-lg text-center flex flex-col items-center">
								
								<div class="mb-3 text-amber-500">
									<BellRingIcon class="w-12 h-12" />
								</div>

								<div class="font-bold text-lg text-amber-800">
									Review
								</div>

								<div class="text-sm text-gray-600 mt-1">
									<span class="font-bold text-gray-800">{{ layout.dataset.globalDataDivision.review }}</span> 
									new Classifications!
								</div>

								<div class="flex justify-center gap-4 mt-5 w-full">

									<button class="flex-1 inline-flex items-center justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2" 
											type="button" 
											@click="handleAcceptReview()">
										<CheckIcon class="w-5 h-5 mr-2 -ml-1" />
										Accept
									</button>
									
									<button class="flex-1 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2" 
											type="button" 
											@click="handleRejectReview()">
										<XIcon class="w-5 h-5 mr-2 -ml-1" />
										Reject
									</button>

									

								</div>
							</div>

							<template v-else>
								<div v-if="classifierState === 'activating' || classifierState === 'caching' || isClassifying">
									
									<div v-if="classifierState === 'activating'" class="space-y-6">
										<div class="flex items-center justify-between">
											<div class="flex items-center space-x-3">
												<div v-if="!classifierSteps.instancePrepared" class="w-5 h-5 border-4 border-t-blue-600 border-gray-200 rounded-full animate-spin"></div>
												<div v-else class="text-green-500 font-bold">✔</div>
												<span class="font-medium" :class="classifierSteps.instancePrepared ? 'text-green-600' : 'text-gray-800'">Starting Instance</span>
											</div>
											<div class="text-sm" :class="classifierSteps.instancePrepared ? 'text-green-600' : 'text-gray-600'">
												{{ classifierSteps.instancePreparedStatus || 'pending' }}
												<small v-if="classifierSteps.instancePrepared">({{ classifierSteps.instancePrepared }} ms)</small>
											</div>
										</div>
										<div class="flex items-center justify-between">
											<div class="flex items-center space-x-3">
												<div v-if="!classifierSteps.modelReady" class="w-5 h-5 border-4 border-t-blue-600 border-gray-200 rounded-full animate-spin"></div>
												<div v-else class="text-green-500 font-bold">✔</div>
												<span class="font-medium" :class="classifierSteps.modelReady ? 'text-green-600' : 'text-gray-800'">Loading Instance</span>
											</div>
											<div class="text-sm" :class="classifierSteps.modelReady ? 'text-green-600' : 'text-gray-600'">
												{{ classifierSteps.modelReadyStatus || 'pending' }}
												<small v-if="classifierSteps.modelReady">({{ classifierSteps.modelReady }} ms)</small>
											</div>
										</div>
									</div>
									<div v-else class="space-y-4">
										<div class="text-sm font-medium text-center text-gray-800">{{ embeddingStatus }}</div>
										<div class="w-full bg-gray-200 rounded-full h-2.5">
											<div class="h-2.5 rounded-full transition-all duration-300"
												:class="isClassifying ? 'bg-purple-600' : 'bg-blue-600'"
												:style="{ width: embeddingProgress + '%' }">
											</div>
										</div>
										<div v-if="isClassifying" class="text-xs text-center text-gray-500">Processing request...</div>
									</div>

								</div>

								<div v-else>

									<div v-if="!isClassifierReady" class="p-3 bg-gray-100 rounded-lg border">
										<div class="flex items-center justify-center">
											<span class="text-xl mr-2">💡</span>
											<div class="text-sm text-gray-700 font-medium">
												<span v-if="classifierState === 'inactive'">
													Requires at least 3 examples per tag to start.
												</span>
												<span v-else-if="classifierState === 'active'">
													Requires at least 3 examples per tag to infer.
												</span>
											</div>
										</div>
									</div>
									
									<div v-else>

										<div v-if="classifierState === 'inactive'"
											class="relative bg-white p-4 pr-3 rounded-lg border border-gray-200 overflow-hidden">
											
											<div class="absolute left-0 top-0 bottom-0 w-1 bg-green-500"></div>

											<div class="ml-3">
												<div class="font-bold text-gray-900">
													Classifier Ready
												</div>

												<p class="text-sm text-gray-500 mt-1 mb-4">
													The service can now be activated.
												</p>

											<button
												type="button"
													@click="activateClassifier()"
													class="rounded-full bg-green-600 px-4 py-1.5 text-sm font-semibold text-white shadow-sm transition-all duration-200 ease-in-out
														hover:bg-green-700 hover:shadow-md hover:-translate-y-px
														focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600">
													Activate
											</button>
											</div>

										</div>

										<div v-if="classifierState === 'active'" class="p-4 space-y-4 bg-white rounded-lg border">
											<div class="font-semibold text-center text-gray-800">Run inference</div>
											<div class="flex items-center space-x-3">
												<span class="text-sm text-gray-600 w-20">Confidence</span>
												<input
													type="range"
													min="0.05"
													max="0.95"
													step="0.05"
													v-model="autolabelThreshold"
													class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer hover:bg-gray-300"
												/>
												<span class="text-sm font-medium text-gray-700 w-10 text-right">{{ autolabelThreshold }}</span>
											</div>
											<div class="text-center border-t border-gray-200 pt-4">
												<button type="button" 
														@click="handleInferClick()"
														class="inline-flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
													<SparklesIcon class="w-5 h-5 mr-2 -ml-1" />
													<span>Auto-classify</span>
												</button>
											</div>
										</div>
									</div>
								</div>
							</template>
							</li>
						</template>

						<!-- IMG OBJECT DETECTION -->
						<template v-if="layout.dataset.type == 'imageObjectDetection'">
							
							<li id="eMobjImages" class="nav selected" @click="labelingMenu('eMobjImages')">
								<span class="text-sm text-gray-700">{{ $t('Images') }}</span>
								<span class="arrow-icon"></span>
							</li>

							<li class="menu-content eMobjImages sel">

								<div v-for="tagType in ['all', 'labeled', 'notLabeled']" :key="tagType" 
									@click="!layout.loading ? layout.optImages.objtagsType = tagType : '';" 
									class="cursor-pointer border px-3 py-2 rounded mb-3"
									:class="layout.optImages.objtagsType==tagType ? 'rp-bg-blue-1 text-white' : 'text-gray-600'"
									:style="layout.loading ? 'cursor: not-allowed' : ''">

									<div v-if="tagType == 'all'">
										<span class="text-sm inline-block mt-0.5">{{ $t('All images') }}</span>
										<div class="py-1 px-2 rounded-full text-xs cursor-pointer font-normal w-24 text-center inline-block float-right" :class="layout.optImages.objtagsType == tagType ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
											{{ layout.loading  ? '...' : layout.dataset?.tagStats.total }}
										</div>
									</div>

									<div v-else>
										<span class="text-sm inline-block mt-0.5">{{ $t(tagType.charAt(0).toUpperCase() + tagType.slice(1).replace(/([A-Z])/g, ' $1')) }}</span>
										<div class="py-1 px-2 rounded-full text-xs cursor-pointer font-normal w-24 text-center inline-block float-right" :class="layout.optImages.objtagsType == tagType ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
											{{ layout.loading  ? '...' : layout.dataset?.tagStats[tagType] }}
										</div>
									</div>

								</div>

							</li>

							<template v-if="layout.dataset?.tagStats && layout.optImages.objtagsType == 'labeled'">
								<li id="eMobjTags" class="nav selected" @click="labelingMenu('eMobjTags')">
									<span class="text-sm text-gray-700">{{ $t('Tags') }}</span>
									<span class="arrow-icon"></span>
								</li>
								<li class="menu-content eMobjTags sel">
									
									<div @click="!layout.loading ? layout.optImages.objByTag = 'all' : '';" 
										class="cursor-pointer border px-3 py-2 rounded mb-3" 
										:class="layout.optImages.objByTag=='all' ? 'rp-bg-blue-1 text-white' : 'text-gray-600'"
										:style="layout.loading ? 'cursor: not-allowed' : ''">
										<span class="text-sm inline-block mt-0.5">{{ $t('All tags') }}</span> 
									</div>

									<div v-for="(tagCount, tagKey) in labeledTags" :key="tagKey" 
										@click="!layout.loading ? layout.optImages.objByTag = tagKey : ''"  
										class="cursor-pointer border p-2 pb-2.5 rounded mb-3"
										:class="layout.optImages.objByTag == tagKey ? 'rp-bg-blue-1 text-white' : 'text-gray-600'"
										:style="layout.loading ? 'cursor: not-allowed' : ''">
										
										<div class="flex items-center justify-between w-full">

											<div class="inline-block align-middle mr-2">
												<div class="mr-1 rounded display-inline roundTagIcon h-5 w-5" 
													:style="layout.dataset.tags[tagKey].color ? 'background-color:' + layout.dataset.tags[tagKey].color + ';border: 2px solid #fff' : ''"></div>
											</div>

											<div class="text-sm mt-1 flex-grow truncate">
												{{ layout.dataset.tags[tagKey].name || tagKey }}
											</div>

											<div class="py-1 px-4 rounded-full text-xs cursor-pointer font-normal w-24 text-center ml-2 flex-shrink-0"
												:class="layout.optImages.objByTag == tagKey ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
												{{ layout.loading ? '...' : $h.formatScore(tagCount) }}
											</div>

										</div>

									</div>

								</li>
							</template>

						</template>

						<!-- MULTILABEL -->
						<template v-if="layout.dataset.type == 'MULTILABEL'">
							
							<li id="eMobjImages" class="nav selected" @click="labelingMenu('eMobjImages')">
								<span class="text-sm text-gray-700">{{ $t('Images') }}</span>
								<span class="arrow-icon"></span>
							</li>

							<li class="menu-content eMobjImages sel">

								<div v-for="tagType in ['all', 'labeled', 'notLabeled', 'normal', 'anomaly']" :key="tagType" 
									@click="!layout.loading ? layout.optImages.objtagsType = tagType : '';" 
									class="cursor-pointer border px-3 py-2 rounded mb-3"
									:class="layout.optImages.objtagsType==tagType ? 'rp-bg-blue-1 text-white' : 'text-gray-600'"
									:style="layout.loading ? 'cursor: not-allowed' : ''">

									<div v-if="tagType == 'all'">
										<span class="text-sm inline-block mt-0.5">{{ $t('All images') }}</span>
										<div class="py-1 px-2 rounded-full text-xs cursor-pointer font-normal w-24 text-center inline-block float-right" :class="layout.optImages.objtagsType == tagType ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
											{{ layout.loading  ? '...' : layout.dataset?.tagStats.total }}
										</div>
									</div>

									<div v-else>
										<span class="text-sm inline-block mt-0.5">{{ $t(tagType.charAt(0).toUpperCase() + tagType.slice(1).replace(/([A-Z])/g, ' $1')) }}</span>
										<div class="py-1 px-2 rounded-full text-xs cursor-pointer font-normal w-24 text-center inline-block float-right" :class="layout.optImages.objtagsType == tagType ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
											{{ layout.loading  ? '...' : layout.dataset?.tagStats[tagType] }}
										</div>
									</div>

								</div>

							</li>

							<template v-if="layout.dataset?.tagStats && layout.optImages.objtagsType == 'anomaly'">
								<li id="eMobjTags" class="nav selected" @click="labelingMenu('eMobjTags')">
									<span class="text-sm text-gray-700">{{ $t('Tags') }}</span>
									<span class="arrow-icon"></span>
								</li>
								<li class="menu-content eMobjTags sel">

									<div @click="!layout.loading ? layout.optImages.objByTag = 'all' : '';" 
										class="cursor-pointer border px-3 py-2 rounded mb-3" 
										:class="layout.optImages.objByTag=='all' ? 'rp-bg-blue-1 text-white' : 'text-gray-600'"
										:style="layout.loading ? 'cursor: not-allowed' : ''">
										<span class="text-sm inline-block mt-0.5">{{ $t('All tags') }}</span>
									</div>

									<div v-for="(tagCount, tagKey) in labeledTags" :key="tagKey" 
										@click="!layout.loading ? layout.optImages.objByTag = tagKey : ''" 
										class="cursor-pointer border p-2 pb-2.5 rounded mb-3" 
										:class="layout.optImages.objByTag == tagKey ? 'rp-bg-blue-1 text-white' : 'text-gray-600'"
										:style="layout.loading ? 'cursor: not-allowed' : ''">
										
										<div class="flex items-center justify-between w-full">

											<div class="inline-block align-middle mr-2">
												<div class="mr-1 rounded display-inline roundTagIcon h-5 w-5" 
													:style="layout.dataset.tags[tagKey].color ? 'background-color:' + layout.dataset.tags[tagKey].color + ';border: 2px solid #fff' : ''"></div>
											</div>

											<div class="text-sm mt-1 flex-grow truncate">
												{{ layout.dataset.tags[tagKey].name || tagKey }}
											</div>

											<div class="py-1 px-4 rounded-full text-xs cursor-pointer font-normal w-24 text-center ml-2 flex-shrink-0"
												:class="layout.optImages.objByTag == tagKey ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
												{{ layout.loading ? '...' : $h.formatScore(tagCount) }}
											</div>

										</div>

									</div>

								</li>
							</template>

						</template>

						<!-- MULTICLASS -->
						<template v-if="layout.dataset.type == 'MULTICLASS' || layout.dataset.type == 'ANOMALY'">
							
							<li id="eMmultiTags" class="nav selected" @click="labelingMenu('eMmultiTags')">
								<span class="text-sm text-gray-700">{{ $t('Tags') }}</span>
								<span class="arrow-icon"></span>
							</li>

							<li class="menu-content eMmultiTags sel">
								
								<template v-if="layout.dataset?.tagStats">

									<template v-if="Object.keys(labeledTags).length <= 50">

										<div @click="!layout.loading ? layout.optImages.objByTag = 'all' : '';" 
											class="cursor-pointer border px-3 py-2 rounded mb-3" 
											:class="layout.optImages.objByTag == 'all' ? 'rp-bg-blue-1 text-white' : 'text-gray-600'" 
											:style="layout.loading ? 'cursor: not-allowed' : ''">
											
											<span class="text-sm inline-block mt-0.5">{{ $t('All') }} </span> 
											
											<div class="py-1 px-4 rounded-full text-xs cursor-pointer font-normal w-24 text-center inline-block float-right" :class="layout.optImages.objByTag == 'all' ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
												{{ layout.loading  ? '...' : $h.formatScore(layout.dataset.tagStats.total) }}
											</div>

										</div>

										<div v-for="(tagCount, tagKey) in labeledTags" :key="tagKey"
											@click="!layout.loading ? layout.optImages.objByTag = tagKey : ''" 
											class="cursor-pointer border p-2 pb-2.5 rounded mb-3" 
											:class="layout.optImages.objByTag == tagKey ? 'rp-bg-blue-1 text-white' : 'text-gray-600'"
											:style="layout.loading ? 'cursor: not-allowed' : ''">
											
											<div class="flex items-center justify-between w-full">

												<div class="inline-block align-middle mr-2">
													<div class="mr-1 rounded display-inline roundTagIcon h-5 w-5" 
														:style="layout.dataset.tags[tagKey].color ? 'background-color:' + layout.dataset.tags[tagKey].color + ';border: 2px solid #fff' : ''"></div>
												</div>

												<div class="text-sm mt-1 flex-grow truncate">
													{{ layout.dataset.tags[tagKey].name || tagKey }}
												</div>

												<div class="py-1 px-4 rounded-full text-xs cursor-pointer font-normal w-24 text-center ml-2 flex-shrink-0"
													:class="layout.optImages.objByTag == tagKey ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
													{{ layout.loading ? '...' : $h.formatScore(tagCount) }}
												</div>

											</div>

										</div>
										
									</template>

									<template v-else>
										<select class="form-select bg-white cursor-pointer w-full mr-5 text-theme-14"
											v-model="layout.optImages.objByTag" @change="reload()">
											<option value="all">{{ $t('All') }}  ({{ layout.dataset?.tagStats?.total ? $h.formatScore(layout.dataset?.tagStats?.total) : "0" }})</option>
											<option v-for="(tagCount, tagKey) in layout.dataset.tags" :key="tagKey" :value="tagKey">
												{{ layout.dataset.tags[tagKey].name ? layout.dataset.tags[tagKey].name : tagKey }} ({{ tagCount ? $h.formatScore(tagCount) : "0" }})
											</option>
										</select>
									</template>

								</template>

								<template v-else>
									<div class="w-52 mr-5 inline-block"><div class="w-8 mr-5 inline-block">
										<LoadingIcon icon="three-dots" class="w-8 h-8 text-white" /></div>
									</div>
								</template>

							</li>

						</template>
						
						<!-- DIVISION SECTION -->
						<li id="eMdatadivision" class="nav selected" @click="labelingMenu('eMdatadivision')">
							<span class="text-sm text-gray-700">{{ $t('Data division') }}</span>
							<span class="arrow-icon"></span>
						</li>

						<li class="menu-content eMdatadivision sel">
							<template v-if="layout.dataset?.tagStats">
								<div v-for="division in visibleDivisions" :key="division"
									@click="!layout.loading ? layout.optImages.division = division : '';" :style="layout.loading ? 'cursor: not-allowed' : ''"
									class="cursor-pointer border px-3 py-2 rounded mb-3 transition-colors duration-200"
									
									:class="{
										'rp-bg-blue-1 text-white': layout.optImages.division == division,
										'bg-purple-100 border-purple-300 text-purple-800 hover:bg-purple-200': division == 'review' && layout.optImages.division != division,
										'text-gray-600 hover:bg-gray-100': division != 'review' && layout.optImages.division != division
									}">

									<div v-if="division == 'all'">
										<span class="text-sm inline-block mt-0.5">{{ $t('All division') }} </span>
										<div class="py-1 px-4 rounded-full text-xs cursor-pointer font-normal w-24 text-center inline-block float-right" :class="layout.optImages.division == division ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
											{{ layout.loading  ? '...' : $h.formatScore(layout.dataset?.dataDivision['total']) }}
										</div>
									</div>
									<div v-else>
										<span class="text-sm inline-block mt-0.5">{{ $t(division.charAt(0).toUpperCase() + division.slice(1)) }}</span>
										<div class="py-1 px-4 rounded-full text-xs cursor-pointer font-normal w-24 text-center inline-block float-right" :class="layout.optImages.division == division ? 'text-gray-700 bg-white' : 'bg-gray-300 text-gray-600'">
											{{ layout.loading  ? '...' : $h.formatScore(layout.dataset?.dataDivision[division]) }}
										</div>
									</div>

								</div>
							</template>
						</li>

					</ul>
				</div>

			</div>
			
		</div>

		<!-- EDITOR COMPONENT -->
		<div v-if="layout.selectedId">
			<EditorCmp 
				:options="{ 
					'id': layout.selectedId, 
					'dataset': layout.dataset, 
					'datasetsList': layout.datasets, 
					'filters': layout.optImages,
					'currentPage': layout.dataset.images.pagination.currentPage
				}"
				@closeEditor="layout.selectedId = false"/>
		</div>



		<!-- MODAL DATA DIVISION -->
		<div id="modal-change-set" class="modal" tabindex="-1" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="rp-overlay h-full"></div>
			<div class="rp-modal" style="width: 470px;">
				<div class="rp-modal-header">
					<h3 class="rp-modal-title">{{ $t('Data division') }}</h3>
					<button class="rp-btn-dismiss" @click="modalClose('modal-change-set')" v-if="!layout.actions.assingLoad">
						<XIcon class="w-5 h-5" />
					</button>
				</div>
				<div class="bg-white p-5">
					<div class="intro-y col-span-12 lg:col-span-12 flex flex-col justify-center items-center mt-5 mb-5" v-if="layout.actions.assingLoad">
						<LoadingIcon icon="ball-triangle" class="w-12 h-12" />
					</div>
					<div v-else>
						<div class="text-lg truncate mb-2"> {{ $t('Selected items') }}: {{countCheck()}}</div>
						<div class="text-xs truncate mb-3"> {{ $t('Select the division you want to assign') }} </div>
						<select class="form-select bg-white cursor-pointer w-full p-2 mb-4" v-model="layout.actions.assingSet">
							<option value="train">{{ $t('Train') }}</option>
							<option value="test">{{ $t('Test') }}</option>
							<option value="validation">{{ $t('Validation') }}</option>
							<option value="predetermined">{{ $t('Predetermined') }}</option>
						</select> 
						<div class="text-left text-xs bg-gray-200 rounded p-5 mb-4">
							<div class="text-lg"><img class="w-5 h-5 inline-block mr-1.5 align-top mt-1" :src="require(`@/assets/images/rosepetal/icon/info.png`)" />  {{ $t('About data division') }}</div>
							<div class="mt-3"><div class="font-medium text-sm">{{ $t('Train') }}</div>{{ $t('Used to adjust the model parameters') }}.</div>
							<div class="mt-2"><div class="font-medium text-sm">{{ $t('Test') }}</div>{{ $t('Used to evaluate the final performance of the model on unseen data and prevent overfitting') }}.</div>
							<div class="mt-2 mb-3"><div class="font-medium text-sm">{{ $t('Validation') }}</div>{{ $t('Used to evaluate the model performance during training and make adjustments to the model') }}.</div>
						</div>
						<div class="rp-modal-body-buttons gap-3 mt-4" style="justify-content: center;">
							<button class="rp-btn-secondary" @click="modalClose('modal-change-set')">
								{{ $t('Cancel') }}
							</button>
							<button class="rp-btn-primary" @click="setDataDivision()" :disabled="!layout.actions.assingSet">
								{{ $t('Confirm') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Download dataset -->
		<div v-if="showDownloadDataset">
			<DownloadDatasetCmp 
				:dataset="layout.dataset"
				:selectedImages="selectedImages"
				:completeDataset="completeDataset"
				@closeModal="showDownloadDataset = false; completeDataset = false"/>
		</div>

		<!-- Assign tag -->
		<div v-if="showAssignTag">
			<AssignTagCmp 
				:dataset="layout.dataset"
				:selectedImages="selectedImages"
				@closeModal="showAssignTag = false"
				@tagAssigned="onTagAssigned"/>
		</div>
		
		<!-- MODAL MOVE IMAGES -->
		<div id="modal-move-selected" class="modal" tabindex="-1" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="rp-overlay h-full"></div>
			<div class="rp-modal" style="width: 470px;">
				<div class="rp-modal-header">
					<h3 class="rp-modal-title">{{ $t('Move images') }}</h3>
					<button class="rp-btn-dismiss" @click="modalClose('modal-move-selected')" v-if="!layout.move.loading">
						<XIcon class="w-5 h-5" />
					</button>
				</div>
				<div class="bg-white p-5">
					<div v-if="layout.move.loading" class="flex flex-col justify-center items-center mt-5 mb-5">
						<LoadingIcon icon="ball-triangle" class="w-12 h-12" />
						<div class="text-normal mt-2">{{ $t('Moving images') }} ({{layout.move.counter}}/{{ selectedImages.length }})</div>
						<div>{{ $t('Please wait...') }}</div>
					</div>

					<div v-else-if="layout.move.success" class="text-center">
						<div class="mb-4">{{ $t('Images have been moved correctly') }}</div>
						<div class="rp-modal-body-buttons gap-3" style="justify-content: center;">
							<button class="rp-btn-primary" @click="modalClose('modal-move-selected')">
								{{ $t('OK') }}
							</button>
						</div>
					</div>

					<div v-else>
						<div class="text-lg truncate mb-2"><span class="font-bold">{{ selectedImages.length }}</span> {{ $t('selected media') }}</div>
						<div class="text-xs truncate mb-3"> {{ $t('Select the destination dataset') }} </div>
						<select class="form-select bg-white cursor-pointer w-full p-2 mb-2" v-model="layout.move.toDataset">
							<option v-for="dataset in actionsDatasets" :value="dataset.id" :key="dataset.id">{{ dataset.name.toString().toLowerCase() }}</option>
						</select> 
						<div class="text-xs text-gray-600 mb-4">{{ $t('Images will be placed in the unclassified tag') }}</div>
						<div class="rp-modal-body-buttons gap-3" style="justify-content: center;">
							<button class="rp-btn-secondary" @click="modalClose('modal-move-selected')">
								{{ $t('Cancel') }}
							</button>
							<button class="rp-btn-primary" @click="moveMedia()" :disabled="!layout.move.toDataset">
								{{ $t('Move') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- MODAL COPY IMAGES -->
		<div id="modal-copy-selected" class="modal" tabindex="-1" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="rp-overlay h-full"></div>
			<div class="rp-modal" style="width: 470px;">
				<div class="rp-modal-header">
					<h3 class="rp-modal-title">{{ $t('Copy images') }}</h3>
					<button class="rp-btn-dismiss" @click="modalClose('modal-copy-selected')" v-if="!layout.copy.loading">
						<XIcon class="w-5 h-5" />
					</button>
				</div>
				<div class="bg-white p-5">
					<div v-if="layout.copy.loading" class="flex flex-col justify-center items-center mt-5 mb-5">
						<LoadingIcon icon="ball-triangle" class="w-12 h-12" />
						<div class="text-normal mt-2">{{ $t('Copying images') }} ({{layout.copy.counter}}/{{ selectedImages.length }})</div>
						<div>{{ $t('Please wait...') }}</div>
					</div>

					<div v-else-if="layout.copy.success" class="text-center">
						<div class="mb-4">{{ $t('Images have been copied correctly') }}</div>
						<div class="rp-modal-body-buttons gap-3" style="justify-content: center;">
							<button class="rp-btn-primary" @click="modalClose('modal-copy-selected')">
								{{ $t('OK') }}
							</button>
						</div>
					</div>

					<div v-else>
						<div class="text-lg truncate mb-2"><span class="font-bold">{{ selectedImages.length }}</span> {{ $t('selected media') }}</div>
						<div class="text-xs truncate mb-3"> {{ $t('Select the destination dataset') }} </div>
						<select class="form-select bg-white cursor-pointer w-full p-2 mb-2" v-model="layout.copy.toDataset">
							<option v-for="dataset in actionsDatasets" :value="dataset.id" :key="dataset.id">{{ dataset.name.toString().toLowerCase() }}</option>
						</select>
						<div class="text-xs text-gray-600 mb-4">{{ $t('Images will be placed in the unclassified tag') }}</div>
						<div class="rp-modal-body-buttons gap-3" style="justify-content: center;">
							<button class="rp-btn-secondary" @click="modalClose('modal-copy-selected')">
								{{ $t('Cancel') }}
							</button>
							<button class="rp-btn-primary" @click="copyMedia()" :disabled="!layout.copy.toDataset">
								{{ $t('Copy') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- MODAL DELETE IMAGES --> 
		<div id="modal-delete" class="modal" tabindex="-1" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="rp-overlay h-full"></div>
			<div class="rp-modal" style="width: 470px;">
				<div class="rp-modal-header">
					<h3 class="rp-modal-title">{{ $t('Delete images') }}</h3>
					<button class="rp-btn-dismiss" @click="modalClose('modal-delete')">
						<XIcon class="w-5 h-5" />
					</button>
				</div>
				<div class="bg-white p-5">
					<div class="text-center">
						<div class="text-lg mb-2">{{ $t('Are you sure you want to delete') }}<br> {{ selectedImages.length }} {{ $t('selected media') }}?</div>
						<div class="text-gray-600 mb-4">{{ $t('This action is irreversible') }}.</div>
						<div class="rp-modal-body-buttons gap-3" style="justify-content: center;">
							<button class="rp-btn-secondary" @click="modalClose('modal-delete')">
								{{ $t('Cancel') }}
							</button>
							<button class="rp-btn-primary" style="background-color: #dc2626; border-color: #dc2626;" @click="deleteImages(); modalClose('modal-delete');">
								{{ $t('Continue') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="modal-help" class="modal" tabindex="-1" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="rp-overlay h-full"></div>
			<div class="rp-modal bg-white rounded-lg shadow-xl overflow-hidden" style="width: 550px; max-width: 90%;">
				
				<div class="rp-modal-header flex items-center justify-between">
					<h3 class="rp-modal-title flex items-center">
						<InfoIcon class="w-5 h-5 mr-2" />
						<span>Auto Classifier Guide</span>
					</h3>
					<button class="rp-btn-dismiss" @click="modalClose('modal-help')">
						<XIcon class="w-5 h-5" />
					</button>
				</div>

				<div class="bg-white p-6 overflow-y-auto" style="max-height: 80vh;">
					
					<div class="mb-6">
						<h4 class="text-lg font-semibold text-gray-800 mb-2">What is it for?</h4>
						<p class="text-sm text-gray-600">
							This tool assists you with the <strong class="font-bold">bulk classification of images</strong>. By providing a few examples for each tag, the classifier learns and can automatically label hundreds of similar images, <strong class="font-bold">drastically reducing your manual labeling time</strong>.
						</p>
					</div>

					<div class="mb-6">
						<h4 class="text-lg font-semibold text-gray-800 mb-2">How does it work?</h4>
						<p class="text-sm text-gray-600 mb-4">
							First, the service must be <strong class="font-bold">started</strong> (Start Service). This initial process can be the slowest as it prepares the images and model, but once active, classifications (inferences) are very fast, allowing for an agile, iterative workflow.
						</p>
					</div>

					<div>
						<h4 class="text-lg font-semibold text-gray-800 mb-3">Recommended Workflow</h4>
						
						<div class="text-sm text-gray-600 space-y-3">
							<div class="p-3 bg-gray-50 rounded-lg">
								<strong class="text-gray-800">✍️ 1. Manual Labeling:</strong> Start by manually labeling a few examples (3 or more) for each class.
							</div>
							<div class="p-3 bg-gray-50 rounded-lg">
								<strong class="text-gray-800">🚀 2. Automatic Inference:</strong> Use the "Auto-classify" button with a high confidence level, for example, 0.85. The classifier will label all the images it is most confident about.
							</div>
							<div class="p-3 bg-gray-50 rounded-lg">
								<strong class="text-gray-800">🧐 3. Refinement:</strong> If some images remain unlabeled, it means the model isn't confident enough. Help it learn! Manually label more of these "difficult" images that were left out. This greatly improves its accuracy.
							</div>
							<div class="p-3 bg-gray-50 rounded-lg">
								<strong class="text-gray-800">🔁 4. Repeat & Consolidate:</strong> Run the inference again. The model will now use all the recent classifications (both manual and automatic) to classify even more images. Repeat this cycle until everything is classified.
								<br><br>
								<strong class="text-gray-800">Pro Tip:</strong> If the process stalls, slightly lower the confidence to help classify the most stubborn images (though this may slightly increase the risk of errors).
							</div>
						</div>

					</div>

				</div>
			</div>
		</div>

	</div>
</template>

<script setup>
import { onMounted, computed, onUnmounted, ref, watch, nextTick } from "vue";
import { useRouter }		from "vue-router";
import { fabric } 			from 'fabric'
import cash     			from "cash-dom";
import lzstring 			from 'lz-string';

import * as rosepetalModel	from "rosepetal-model";
import config				from '@/etc/rosepetal.json';
import { helper as $h } 	from "@/utils/helper";

import EditorCmp			from "@/components/manage-image/Editor.vue";
import DownloadDatasetCmp 	from "@/modals/dataset/DownloadDataset.vue";
import AssignTagCmp 		from "@/modals/tag/AssignTag.vue";

const imageDimensionsCache = new Map();

const getOriginalImageDimensions = async (image) => {
    if (imageDimensionsCache.has(image.id)) {
        return imageDimensionsCache.get(image.id);
    }

    const url = image.imageData?.reducedImg || image.imageData?.originalImg || image.img_base64_val;
    if (!url) {
		console.warn(`No reduced or original image URL for ${image.id}`);
		return null;
	}

    try {
        const tempImg = new Image();
        tempImg.crossOrigin = "anonymous";
        tempImg.src = url;
        await new Promise((resolve, reject) => {
            tempImg.onload = resolve;
            tempImg.onerror = reject;
        });
        const dimensions = { width: tempImg.width, height: tempImg.height };
        imageDimensionsCache.set(image.id, dimensions);
        return dimensions;
    } catch (e) {
        console.error(`Could not load image to get dimensions for ${image.id}`, url, e);
        return null;
    }
}

let $dataset	= rosepetalModel.default.dataset;
let $image		= rosepetalModel.default.image;

let $embedd 	= rosepetalModel.default.embedd;
let $vlm 		= rosepetalModel.default.vlm;
let $firebase = rosepetalModel.default._firebase;

const labeledTags = computed(() => { 
	const tags = layout.value.dataset.tagStats.tags;

	let excludeTags = [];
	switch (layout.value.dataset.type) {
		case "MULTILABEL":
			excludeTags = ["0", "OK"];
			break;
		case 'imageObjectDetection':
			excludeTags = ["0"];
			break;
		default:
			excludeTags = [];
	}

	const sortedTags = Object.keys(tags)
		.filter(key => !excludeTags.includes(key) && tags[key] !== null && tags[key] !== undefined)
		.sort()
		.reduce((acc, key) => {
			acc[key] = tags[key];
			return acc;
		}, {});
	return sortedTags;
});
		
const actionsDatasets = computed(() => {
	return layout.value.datasets.filter(dataset => dataset.id !== layout.value.dataset.id);
});

const props = defineProps({
	options: {
		type: Object,
		required: true
	},
});

const router 				= useRouter();
const selectedImages  		= ref([]);
const selectToDataset 		= ref([]);
const downloadImg 			= ref(false);
const lastClickedIndex		= ref(-1);

const responsiveGroupSize	= ref(false);
const fixedGroupSize		= ref(false);
const showResponsive 		= ref(false);

const completeDataset		= ref(false);

const showDownloadDataset	= ref(false);
const showAssignTag			= ref(false);

let filteredImages = [];

const layout = ref({
	canvasList:   	[],
	dataset:      	false,
	datasets:     	[],
	edit:         	false,
	selectedId:   	false,
	loading:      	true,
	tagsListener: 	false,
	pagination:   	false,
	optImages:    { 
		datasetID:		props.options.dataset, 
		objtagsType:	'all', 
		objByTag:		'all', 
		division:		'all',
		order:			'date',
		direction:		'desc',
		name:			'',
		mediaSize:		window.innerWidth < 900 ? 3 : 2,
		windowWidth:	window.innerWidth,
		mediaLabel:		true,
		mediaName:		true, 
		mediaMask:		false,
		mediaBounding:	false,
		mediaSet:		true,
		mediaDate:		true,
		maskOpacity:	0.5,
		perPage:		50
	},
	zip:  { loading: false, counter: 0 },
	move: { loading: false, toDataset: "", counter: 0 },
	copy: { loading: false, toDataset: "", counter: 0 },
	actions: { assingLoad: false, assingSet: false, assingTag: false }
});

const modal       	= (m) => { cash("#" + m).modal("show"); cash(".main").removeClass("overflow-y-hidden")}
const modalClose	= (m) => { cash("#" + m).modal("hide"); }

const labelingMenu = (menuId) => {
	const menuElement = document.getElementById(menuId);
	if (!menuElement) return;
	
	menuElement.classList.toggle('selected');
	
	const menuContents = document.getElementsByClassName(menuId);
	Array.from(menuContents).forEach(content => {
		content.classList.toggle('sel');
	});
}

const check 		= () => { selectedImages.value = []; for (let i in layout.value.dataset.images.media) { selectedImages.value.push(layout.value.dataset.images.media[i].id); } }
const unCheck 		= () => { completeDataset.value = false; selectedImages.value = []; }
const countCheck 	= () => { return selectedImages.value.length ? selectedImages.value.length : 0; }

const isImageLabeled = (image) => {
	if (layout.value.dataset.type === 'imageObjectDetection') {
		return image?.tags && image.tags.length > 0;
	}
	if (layout.value.dataset.type === 'MULTILABEL') {
		return (image?.tags && image.tags.length > 0) || (image?.mask && image.mask.imageJson);
	}
	return false;
}

const loadedImages = ref(new Set());

const onPreviewLoaded = (image) => {
	loadedImages.value.add(image.id);
	setTimeout(() => {
		renderImage(image);
	}, 10);
};

const onLowResLoaded = (image) => {
	loadedImages.value.add(image.id);
	
	const lowResImg = document.getElementById('lowResImg_' + image.id);
	if (lowResImg) {
		lowResImg.style.opacity = '1';
	}
	
	setTimeout(() => {
		renderImage(image);
	}, 50);
};

const onImageError = (image) => {
	console.warn(`Failed to load image ${image.id}`);
};

const preloadNearbyImages = async () => {
	if (!layout.value.dataset?.images?.media) return;
	
	const images = layout.value.dataset.images.media;
	
	let preloadCount = 0;
	for (let i = 0; i < images.length && preloadCount < 5; i++) {
		const image = images[i];
		if (!loadedImages.value.has(image.id) && image.imageData?.lowResImg) {
			const preloadImg = new Image();
			preloadImg.src = image.imageData.lowResImg;
			preloadCount++;
		}
	}
};

const handleResize = async function() {
	const filtersLabeling	= document.querySelector('#rpFiltersLabeling');
	showResponsive.value = (fixedGroupSize.value + responsiveGroupSize.value) > filtersLabeling.offsetWidth;

	filteredImages.forEach(image => { 
		if (loadedImages.value.has(image.id)) {
			renderImage(image); 
		}
	});
}

const checkItem = async (imgSelected, event = null) => {
	if (event?.shiftKey) {
		event.preventDefault();
		if (window.getSelection) {
			window.getSelection().removeAllRanges();
		}
	}
	
	const currentIndex = layout.value.dataset.images.media.findIndex(img => img.id === imgSelected.id);
	
	if (event?.shiftKey && lastClickedIndex.value !== -1) {
		const start = Math.min(lastClickedIndex.value, currentIndex);
		const end = Math.max(lastClickedIndex.value, currentIndex);
		const isSelected = selectedImages.value.includes(imgSelected.id);
		
		for (let i = start; i <= end; i++) {
			const img = layout.value.dataset.images.media[i];
			if (!img) continue;
			
			const exists = selectedImages.value.includes(img.id);
			if (isSelected && exists) {
				selectedImages.value = selectedImages.value.filter(id => id !== img.id);
			} else if (!isSelected && !exists) {
				selectedImages.value.push(img.id);
			}
		}
	} else {
		const exists = selectedImages.value.includes(imgSelected.id);
		if (exists) {
			selectedImages.value = selectedImages.value.filter(id => id !== imgSelected.id);
		} else {
			selectedImages.value.push(imgSelected.id);
		}
	}
	
	lastClickedIndex.value = currentIndex;
}

//AutoClassification

const classifierState = ref('inactive'); 
const isReviewing = ref(false);

const classifierSteps = ref({
    instancePrepared: 0,
    instancePreparedStatus: '',
    modelReady: 0,
    modelReadyStatus: '',
});

const embeddingStatus = ref('Starting...');
const embeddingProgress = ref(0);

let unsubscribeListeners = [];

let classifierTimeoutId = null;

const hasReviewImages = computed(() => {
    return layout.value.dataset?.globalDataDivision?.review > 0;
});

const isClassifierReady = computed(() => {
    const allTags = layout.value.dataset?.tagStats?.tags;

    if (!allTags) {
        return false;
    }

    const relevantTagCounts = Object.entries(allTags)
        .filter(([key, value]) => key !== '0')
        .map(([key, value]) => value);

    if (relevantTagCounts.length === 0) {
        return false;
    }

    return relevantTagCounts.every(count => count >= 3);
});

const handleAcceptReview = async () => {
    if (isReviewing.value) return;
    isReviewing.value = true;
    try {
        await $embedd.classificationReviewAction(layout.value.dataset.id, 'accept');
        
    } catch (error) {
        console.error("Error accepting review:", error);
    } finally {
		await reload(true);
        isReviewing.value = false;
    }
};

const handleRejectReview = async () => {
    if (isReviewing.value) return;
    isReviewing.value = true;
    try {
        await $embedd.classificationReviewAction(layout.value.dataset.id, 'rollback');
        
    } catch (error) {
        console.error("Error rejecting review:", error);
    } finally {
		await reload(true);
        isReviewing.value = false;
    }
};


function stopTrackingEmbeddStatus() {
    if (unsubscribeListeners.length > 0) {
        console.log("Stopping Firebase listeners.");
        unsubscribeListeners.forEach(unsub => unsub());
        unsubscribeListeners = [];
    }
}

function startTrackingEmbeddStatus() {
    stopTrackingEmbeddStatus(); 
    const datasetId = layout.value.dataset.id;
    if (!datasetId) return;

    console.log(`Starting listeners for dataset: ${datasetId}`);

    const unsubStatus = $firebase.trackDocumentFieldChanges('dataset', datasetId, 
        (newValue) => {
            embeddingStatus.value = newValue; 
        }, 
        'embedd_status'
    );

    const unsubProgress = $firebase.trackDocumentFieldChanges('dataset', datasetId, 
        (newValue) => {
            embeddingProgress.value = newValue; 
        }, 
        'embedd_progress'
    );

    unsubscribeListeners.push(unsubStatus, unsubProgress);
}


function deactivateClassifier() {
    classifierState.value = 'inactive';
    stopTrackingEmbeddStatus();
    if (classifierTimeoutId) {
        clearTimeout(classifierTimeoutId);
        classifierTimeoutId = null;
    }
    console.log('Auto Classifier service deactivated.');
}

const activateClassifier = async () => {
	if (!isClassifierReady.value) {
        console.warn("Start blocked, not enough examples.");
        return;
    }
    classifierState.value = 'activating';
    classifierSteps.value = { instancePrepared: 0, instancePreparedStatus: '', modelReady: 0, modelReadyStatus: '' };

    try {
        let t0 = Date.now();
        const orchResult = await $vlm.checkOrchestratorHealth(config.firebaseConfig.projectId);
        classifierSteps.value.instancePrepared = Date.now() - t0;
        classifierSteps.value.instancePreparedStatus = orchResult.status || 'OK';
        
        t0 = Date.now();
        const embeddResult = await $embedd.checkEmbeddhealth(config.firebaseConfig.projectId);
        classifierSteps.value.modelReady = Date.now() - t0;
        classifierSteps.value.modelReadyStatus = embeddResult.status || 'OK';

        await new Promise(resolve => setTimeout(resolve, 1000));

        classifierState.value = 'caching';
        
        embeddingStatus.value = "Initializing...";
        embeddingProgress.value = 0;
        
        startTrackingEmbeddStatus();
        
        console.log("Sending cache request and waiting for API response...");
        const resp = await $embedd.cache(config.firebaseConfig.projectId, layout.value.dataset.id, "CLASSIFICATION");
        console.log("Cache process finished on the backend. API responded:", resp);
        
        stopTrackingEmbeddStatus();
        
        embeddingStatus.value = "Cache Ready";
        embeddingProgress.value = 100;
        await new Promise(resolve => setTimeout(resolve, 1200));

        classifierState.value = 'active';
        resetClassifierTimeout();

    } catch (error) {
        console.error("Failed during activation or caching process:", error);
        deactivateClassifier();
    }
};

const resetClassifierTimeout = async () => {
    await $embedd.checkEmbeddhealth(config.firebaseConfig.projectId); 
    if (classifierTimeoutId) clearTimeout(classifierTimeoutId);
    classifierTimeoutId = setTimeout(deactivateClassifier, 600000); 
    console.log('Auto Classifier timeout reset.');
}


const isClassifying = ref(false);
const autolabelThreshold = ref(0.80);

const handleInferClick = async () => {
	if (!isClassifierReady.value) {
        console.warn("Inference blocked, not enough examples.");
        return;
    }
    if (isClassifying.value) return;
    
    try {
        isClassifying.value = true;
        
        embeddingStatus.value = "Inferring...";
        embeddingProgress.value = 0;

        startTrackingEmbeddStatus();
        
        console.log("Sending predict request and waiting for completion...");
	await $dataset.updateCsv({ dataset: layout.value.dataset });
        await $embedd.predict(config.firebaseConfig.projectId, layout.value.dataset.id, "CLASSIFICATION", autolabelThreshold.value);
        console.log("Inference process finished on the backend.");

    } catch (error) {
        console.error("Error during inference:", error);
    } finally {
        console.log("Cleaning up after inference.");
        
        stopTrackingEmbeddStatus();
        
        isClassifying.value = false;
        
        reload(true);
    }
};

const visibleDivisions = computed(() => {
    const standardDivisions = ['all', 'train', 'test', 'validation', 'predetermined'];
    const dataDivision = layout.value.dataset?.dataDivision;

    if (dataDivision && dataDivision['review'] && dataDivision['review'] > 0) {
        return ['review', ...standardDivisions];
    }

    return standardDivisions;
});

const setDataDivision = async () => { 
	layout.value.actions.assingLoad = true;
	let cnt = 0;

	for (const s of selectedImages.value) {
		await $image.setSet(s, layout.value.actions.assingSet.toString().toUpperCase());
		cnt++;
	}

	setTimeout(async () => {
		let currentSelectedImages = selectedImages.value;
		$h.NotificationTxt({ text: cnt + " media set updated" });
		modalClose("modal-change-set");
		layout.value.actions.assingSet = false;
		layout.value.actions.assingLoad = false;
		await loadImages();
		selectedImages.value = currentSelectedImages;
	}, 1000);
}

const onTagAssigned = async () => {
	const imagesToUpdate = layout.value.dataset.images.media
		.filter(img => img.set === 'REVIEW' && selectedImages.value.includes(img.id));

	const updatePromises = imagesToUpdate.map(img => $image.setSet(img.id, 'PREDETERMINED'));

	await Promise.all(updatePromises);

	const { tagStats } = await $dataset.get(props.options.dataset.id, { tagStats: true });
	sessionStorage.setItem('datasetData', JSON.stringify({ ...layout.value.dataset, tagStats }));
	layout.value.dataset.tagStats = tagStats;

    unCheck(); 
    await loadImages();

	if(imagesToUpdate.length > 0) {
		reload(true);
	} 
}

const load = async (reload = false) => {
	let datasetData = JSON.parse(sessionStorage.getItem('datasetData'));
	
	if (!datasetData || !datasetData.tagStats || reload) {
		layout.value.dataset = await $dataset.get(props.options.dataset.id, { tagStats: true });
	} else {
		layout.value.dataset = datasetData;
	}
	const globalDivisions = await $dataset.getDivisionStats(layout.value.dataset, false, false);
	layout.value.dataset.globalDataDivision = globalDivisions;
	
	layout.value.datasets = await $dataset.list();

	await loadImages();
	console.log("Dataset loaded", layout.value.dataset);
}

const loadImages = async () => { 
	const paginationActions = ['firstPage', 'previousPage', 'selectedPage', 'nextPage', 'lastPage'];
	if (!paginationActions.includes(layout.value.optImages.action)) {
		selectedImages.value = [];
	}

	let opt = { 
		dataset: 		layout.value.dataset,
		objDivision: 	layout.value.optImages.division !== 'all' ? layout.value.optImages.division : 'all',
		objByTag: 		layout.value.optImages.objByTag !== 'all' ? layout.value.optImages.objByTag : 'all',
		perPage: 		layout.value.optImages.perPage,
		action: 		layout.value.optImages.action || false,
		order: 			layout.value.optImages.order || false,
		direction: 		layout.value.optImages.direction || false,
		paginationQry:	layout.value.pagination || false
	};

	if (layout.value.dataset.type == 'imageObjectDetection' || layout.value.dataset.type == 'MULTILABEL') {
		opt.objtagsType = layout.value.optImages.objtagsType ? layout.value.optImages.objtagsType : 'all';
	}

	let objtagsType	= opt.objtagsType != 'all' ? opt.objtagsType : false;
	let objByTag	= opt.objByTag != 'all' ? opt.objByTag : false;

	const [divisions, images] = await Promise.all([
		$dataset.getDivisionStats(layout.value.dataset, objtagsType, objByTag),
		$dataset.getImages(layout.value.dataset, opt)
	]);

	layout.value.dataset.dataDivision = divisions;
	layout.value.dataset.images = images;

	if (layout.value.optImages.division === 'review') {
		if (!layout.value.dataset.dataDivision['review'] || layout.value.dataset.dataDivision['review'] === 0) {
			layout.value.optImages.division = 'all';
            return;
		}
	}

	filteredImages = layout.value.dataset.images.media;

	layout.value.pagination			= layout.value.dataset.images.pagination || false;
	layout.value.optImages.action	= false;

	await nextTick();
	
	loadedImages.value.clear();
	
	setTimeout(() => {
		preloadNearbyImages();
	}, 2000);

	layout.value.loading = false;
}

const renderImage = async (image) => {
	const canvasId = "thumbCanvas_" + image.id;
	const canvas = document.getElementById(canvasId);
	if (!canvas) return;

	const ctx = canvas.getContext("2d");
	const showMask = layout.value.optImages.mediaMask;
	const showBounding = layout.value.optImages.mediaBounding;

	if (!showMask && !showBounding) {
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		return;
	}

	const container = canvas.parentElement;
	const containerWidth = container.offsetWidth;
	const containerHeight = container.offsetHeight;
	
	canvas.width = containerWidth;
	canvas.height = containerHeight;
	ctx.clearRect(0, 0, canvas.width, canvas.height);

	const originalDimensions = await getOriginalImageDimensions(image);
	if (!originalDimensions) return;

	const scaleX = canvas.width / originalDimensions.width;
	const scaleY = canvas.height / originalDimensions.height;
	const scale = Math.max(scaleX, scaleY);

	const scaledWidth = originalDimensions.width * scale;
	const scaledHeight = originalDimensions.height * scale;
	const offsetX = (canvas.width - scaledWidth) / 2;
	const offsetY = (canvas.height - scaledHeight) / 2;

	image.__canvasInfo = {
		canvas,
		ctx,
		scale,
		offsetX,
		offsetY,
		imgW: originalDimensions.width,
		imgH: originalDimensions.height,
		scaledWidth,
		scaledHeight
	};

	ctx.save();
	ctx.beginPath();
	ctx.rect(offsetX, offsetY, scaledWidth, scaledHeight);
	ctx.clip();

	if (showMask && image?.masks) {
		await renderMasks(image);
	}

	if (showBounding && image?.tags) {
		await renderDetections(image);
	}

	ctx.restore();
}

const renderMasks = async(image) => {
	const canvas = image.__canvasInfo.canvas;
	const ctx = image.__canvasInfo.ctx;
	
	if (!image.masks || !Array.isArray(image.masks)) {
		return;
	}
	
	const scale = image.__canvasInfo.scale;
	const offsetX = image.__canvasInfo.offsetX;
	const offsetY = image.__canvasInfo.offsetY;
	
	for (const mask of image.masks) {
		if (!mask.paths || !Array.isArray(mask.paths)) {
			continue;
		}
		
		const tagId = mask.tag.path ? mask.tag.path.split('/').pop() : mask.tag.id;
		const tagData = layout.value.dataset.tags[tagId];
		if (!tagData) continue;
		
		ctx.globalAlpha = 0.6;
		ctx.strokeStyle = tagData.color || '#ff0000';
		ctx.fillStyle = tagData.color || '#ff0000';
		ctx.lineWidth = 2;
		
		for (const compressedPath of mask.paths) {
			try {
				let pathData;
				
				if (typeof compressedPath === 'string') {
					pathData = JSON.parse(lzstring.decompressFromBase64(compressedPath));
				} else if (compressedPath && typeof compressedPath === 'object') {
					pathData = compressedPath;
				} else {
					continue;
				}
				
				if (!pathData || pathData.type !== 'path' || !Array.isArray(pathData.path)) {
					continue;
				}
				
				ctx.beginPath();
				
				for (const command of pathData.path) {
					if (!Array.isArray(command) || command.length === 0) continue;
					
					const type = command[0];
					
					switch (type) {
						case 'M':
							if (command.length >= 3) {
								ctx.moveTo(
									command[1] * scale + offsetX,
									command[2] * scale + offsetY
								);
							}
							break;
							
						case 'L':
							if (command.length >= 3) {
								ctx.lineTo(
									command[1] * scale + offsetX,
									command[2] * scale + offsetY
								);
							}
							break;
							
						case 'C':
							if (command.length >= 7) {
								ctx.bezierCurveTo(
									command[1] * scale + offsetX,
									command[2] * scale + offsetY,
									command[3] * scale + offsetX,
									command[4] * scale + offsetY,
									command[5] * scale + offsetX,
									command[6] * scale + offsetY
								);
							}
							break;
							
						case 'Q':
							if (command.length >= 5) {
								ctx.quadraticCurveTo(
									command[1] * scale + offsetX,
									command[2] * scale + offsetY,
									command[3] * scale + offsetX,
									command[4] * scale + offsetY
								);
							}
							break;
							
						case 'Z':
							ctx.closePath();
							break;
					}
				}
				
				ctx.fill();
				ctx.stroke();
				
			} catch (error) {
				console.error('Error rendering mask path:', error);
			}
		}
	}
}

const renderDetections = async(image) => {
	const canvas = image.__canvasInfo.canvas;
	const ctx = image.__canvasInfo.ctx;
	
	if (!image.tags || !Array.isArray(image.tags)) {
		return;
	}
	
	const scale = image.__canvasInfo.scale;
	const offsetX = image.__canvasInfo.offsetX;
	const offsetY = image.__canvasInfo.offsetY;
	
	for (const detection of image.tags) {
		if (detection.type !== "rect") continue;
		
		const tagId = detection.tag.path ? detection.tag.path.split('/').pop() : detection.tag.id;
		const tagData = layout.value.dataset.tags[tagId];
		if (!tagData) continue;
		
		const x = detection.x * image.__canvasInfo.imgW * scale + offsetX;
		const y = detection.y * image.__canvasInfo.imgH * scale + offsetY;
		const width = detection.w * image.__canvasInfo.imgW * scale;
		const height = detection.h * image.__canvasInfo.imgH * scale;
		
		ctx.fillStyle = tagData.color || '#ff0000';
		ctx.globalAlpha = 0.4;
		ctx.fillRect(x, y, width, height);
		
		ctx.strokeStyle = tagData.color || '#ff0000';
		ctx.lineWidth = 2;
		ctx.globalAlpha = 0.8;
		ctx.strokeRect(x, y, width, height);
		
		ctx.fillStyle = tagData.color || '#ff0000';
		ctx.globalAlpha = 1.0;
		ctx.font = '12px Arial';
		ctx.fillText(tagData.name || tagId, x + 2, y - 4);
	}
}

const filterImages = async () => {
	const searchTerm = layout.value.optImages.name.toLowerCase();
	const filtered = filteredImages.filter(image => 
		image.name.toLowerCase().includes(searchTerm)
	);

	layout.value.dataset.images.media = [];
	
	await nextTick();
	layout.value.dataset.images.media = [...filtered];
	
	loadedImages.value.clear();
}

const deleteImages = async () => { 
	cash("#modal-delete").modal("hide");
	layout.value.loading = true;
	resetPagination();
	await $dataset.deleteImagesBatch(props.options.dataset , JSON.stringify(selectedImages.value)).then(async () => {
		$h.NotificationTxt({ text: "Images successfully removed", position: "right" });
		await load(true);
	});
}

const reload = async (reload = false) => { 
	if (props.options.dataset) {
		layout.value.loading = true; 
		layout.value.canvasList	= [];
		if (reload) {
			await load(true);
		} else {
			await loadImages();
		}
		console.log("Reload completed", { 
			pagination: layout.value.dataset?.images?.pagination,
			mediaCount: layout.value.dataset?.images?.media?.length 
		});
	}
}

const resetPagination = async () => { 
	layout.value.pagination = false; 
	layout.value.optImages.action = false;
	layout.value.dataset.images = {};
}

const downloadCSV = async () => {
	const csvResp	= await $dataset.updateCsv({ dataset: layout.value.dataset });
	const res 	= await fetch(csvResp.url);
	const blob 	= await res.blob();
	const blobUrl = window.URL.createObjectURL(blob);
	
	const link = document.createElement('a');
	link.href = blobUrl;
	link.setAttribute('download', layout.value.dataset.id + '.csv');
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(blobUrl);
}

const moveMedia = async () =>  { 
	if (!layout.value.move.toDataset) alert('Select a dataset to move the images')
	else {
		layout.value.move.loading = true;
		layout.value.move.counter = 0;
		let imagesMoveList       = { images: {} }

		for (let i = 0; i < selectedImages.value.length; i++) {
			if (selectedImages.value[i]) {
				layout.value.move.counter++;
				imagesMoveList.images[selectedImages.value[i].toString().replace(/'/g,"")] = "0";
			}
		}

		if (Object.keys(imagesMoveList.images).length)
			await $dataset.createOperation(layout.value.move.toDataset, { images: imagesMoveList.images, type: 'move' }, config.functions.usapi);
		
		layout.value.move.success   = true;
		layout.value.move.loading   = false;
		resetPagination();
		await loadImages();
	}
}

const copyMedia = async () => { 
	if (!layout.value.copy.toDataset) {
		alert('Select a dataset to copy the images')
	} else {
		layout.value.copy.loading = true;
		layout.value.copy.counter = 0;
		let imagesCopyList       = { images: {} }

		const toDatasetTags = Object.keys(await $dataset.getTags(layout.value.copy.toDataset));

		for (let i = 0; i < selectedImages.value.length; i++) {
			const imageId = selectedImages.value[i].toString().replace(/'/g,"");
			layout.value.copy.counter++;

			const tagDoc = await $image.getTags(imageId);
			const imageTag = tagDoc['tags'][0]['tag'];

			if (!toDatasetTags.includes(imageTag)) {
				await $dataset.createTag(layout.value.copy.toDataset, { tag: imageTag })
			}

			imagesCopyList.images[imageId] = imageTag;
		}
		
		if (Object.keys(imagesCopyList.images).length) {
			await $dataset.createOperation(layout.value.copy.toDataset, { images: imagesCopyList.images, type: 'copy' });
		}

		layout.value.copy.success   = true;
		layout.value.copy.counter   = 0;
		layout.value.copy.loading   = false;
	}
}

onMounted(async () => {
	console.log("Mounted Labeling");

	router.push('/datasets/' + props.options.dataset.id + '/labeling');

	window.addEventListener('resize', handleResize);
	cash("#rpTopBarLine").hide();

	if (props.options.dataset) { 
		await load();
	}

	cash("body").css("overflow-y", "hidden");
});

onUnmounted(async () => { 
	console.log("Unmounted labeling")

	window.removeEventListener('resize', handleResize);
	//await closeLabeling();

	cash("body").css("overflow-y", "scroll");
	cash(".wrapper-box .content").removeClass("singlemode_wrapper");
	cash("#rpTopBarLine").show();
});

watch(() => props.options.dataset, async () => {
	console.log("Watcher prop.options.dataset");
	layout.value.edit = false;
	layout.value.optImages.objtagsType = 'all';
	layout.value.optImages.objByTag = 'all';
	layout.value.optImages.division = 'all';
	resetPagination(); 
	await load();
});

watch(() => layout.value.optImages.mediaSize, async () => { 
	console.log("Watcher layout.value.optImages.mediaSize");
	await nextTick();
	await handleResize();
});

watch(() => layout.value.optImages.division , async () => {
	console.log("Watcher layout.value.optImages.division");
	layout.value.loading = true; 
	resetPagination();
	await loadImages();
});

watch(() => layout.value.optImages.objtagsType , async () => {
	console.log("Watcher layout.value.optImages.objtagsType");
	layout.value.loading = true;
	layout.value.optImages.objByTag = 'all';
	layout.value.optImages.division = 'all';
	resetPagination();
	await loadImages();
});

watch(() => layout.value.optImages.objByTag , async () => { 
	console.log("Watcher layout.value.optImages.objByTag");
	layout.value.loading = true;
	resetPagination();
	await loadImages();
});

watch(
	() => [
		layout.value.optImages.perPage,
		layout.value.optImages.order,
		layout.value.optImages.direction,
	],
	async () => {
		resetPagination();
		await loadImages();
	}
);

watch(() => layout.value.optImages.mediaMask, () => {
	if (!layout.value.dataset?.images?.media) return;
	
	layout.value.dataset.images.media.forEach(image => {
		if (loadedImages.value.has(image.id)) {
			renderImage(image);
		}
	});
});

watch(() => layout.value.optImages.mediaBounding, () => {
	if (!layout.value.dataset?.images?.media) return;
	
	layout.value.dataset.images.media.forEach(image => {
		if (loadedImages.value.has(image.id)) {
			renderImage(image);
		}
	});
});

watch(() => layout.value.selectedId, (newVal) => {
    if (newVal) {
        const dropdownMenu = document.querySelector('.rpLabelingTopMenu');
        if (dropdownMenu) {
            dropdownMenu.style.display = 'none';
        }
    }
});
</script>

<style>
.rpLabelingTopMenu { z-index: 99999999 !important; margin-top: 5px !important; }

.rpLabelingMenu { 
  width: 100%;
  font-size: 14px;
}

.rpLabelingMenu li { 
  margin-bottom: 0 !important; 
  padding: 0 !important;
  background-color: transparent !important;
  cursor: default !important;
}

.rpLabelingMenu ul li:hover { 
  background-color: transparent !important;
}

.rpLabelingMenu ul li.selected { 
  background-color: transparent !important;
}

.rpLabelingMenu ul li .arrow { 
  display: none !important;
}

.rpLabelingMenu ul li.menu-content { 
  background-color: #fff !important;
  padding: 0 !important;
  font-size: 14px !important;
  display: none !important;
  cursor: default !important;
  max-height: 0 !important;
  overflow: hidden !important;
  transition: max-height 0.3s ease-out !important;
}

.rpLabelingMenu ul li.menu-content.sel{ 
  display: block !important;
  padding: 1rem !important;
  max-height: 500px !important;
  transition: max-height 0.3s ease-in !important;
  overflow-y: auto !important;
}

.labelingBox {  
  position: fixed; 
  top: 0; 
  left: 0; 
  min-height: 100%; 
  width: 100% !important; 
  z-index: 9999 !important; 
}

/* Action buttons styling to match editor */
.labeling-action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.15s ease;
  background-color: transparent;
  border-radius: 0;
  border: none;
  cursor: pointer;
  height: 100%;
  overflow: hidden;
}

.labeling-action-button:hover {
  background-color: var(--primary-50, #edf2fa);
  box-shadow: inset 0 -1px 0 var(--primary-300, #7c9fd7);
}

.labeling-action-button:active {
  background-color: var(--primary-100, #d2dff0);
}

.labeling-action-icon {
  width: 16px; 
  height: 16px;
  color: var(--primary-600, #1e4591);
  stroke-width: 1.5px;
  opacity: 0.85;
}

.labeling-action-button:hover .labeling-action-icon {
  opacity: 1;
}

/* Pagination buttons */
.pagination-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background-color: transparent;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #6b7280;
}

.pagination-btn:hover {
  background-color: var(--primary-50, #edf2fa);
  color: var(--primary-600, #1e4591);
  border-color: var(--primary-300, #7c9fd7);
}

.pagination-select {
  padding: 4px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  margin: 0 4px;
}

.pagination-select:hover {
  border-color: var(--primary-300, #7c9fd7);
}

/* Form selects */
.labeling-select {
  padding: 4px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  min-width: 80px;
}

.labeling-select:hover {
  border-color: var(--primary-300, #7c9fd7);
}

:root {
  --primary-50: #edf2fa;
  --primary-100: #d2dff0;
  --primary-200: #a7bfe4;
  --primary-300: #7c9fd7;
  --primary-400: #517fc9;
  --primary-500: #3664b3;
  --primary-600: #1e4591;
  --primary-700: #17356e;
  --primary-800: #10254c;
  --primary-900: #081529;
}

/* Menu styling to match editor */
.rpLabelingMenu li.nav {
  font-size: 15px !important;
  color: #374151 !important;
  padding: 0.75rem 1rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  background-color: #f8fafc !important;
  cursor: pointer !important;
  border-bottom: 1px solid #e5e7eb !important;
  margin-bottom: 0 !important;
}

.rpLabelingMenu li.nav:hover {
  background-color: #f1f5f9 !important;
}

.rpLabelingMenu li.nav.selected {
  background-color: #f1f5f8 !important;
  font-weight: 500 !important;
}

.arrow-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2394a3b8'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.2s ease;
  transform: rotate(0deg);
}

.rpLabelingMenu li.nav.selected .arrow-icon {
  transform: rotate(180deg);
}

.menu-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  background-color: #fff;
  padding: 0;
  margin: 0;
  font-size: 14px;
  cursor: default;
}

.menu-content.sel {
  max-height: 500px;
  padding: 1rem;
  transition: max-height 0.3s ease-in;
  overflow-y: auto;
  background-color: #fff;
}

/* Image grid spacing */
.intro-y.grid.grid-cols-12 {
  gap: 1rem !important;
}

.intro-y.grid .rounded-lg {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.aspect-square img {
  transition: opacity 0.3s ease-in-out;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}

.aspect-square canvas {
  z-index: 3;
  pointer-events: none;
  object-fit: contain;
}

.aspect-square img[id^="lowResImg_"] {
  z-index: 2;
}

.aspect-square {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
}

/* SELECTION ACTION BUTTONS AND LINKS */
.selection-action-link {
  color: var(--primary-600, #1e4591);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s ease;
}

.selection-action-link:hover {
  color: var(--primary-800, #10254c);
  text-decoration: underline;
}

.selection-action-button,
.dataset-action-button {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 4px 12px !important;
  border-radius: 4px !important;
  font-size: 14px !important;
  font-weight: normal !important;
  border: 1px solid #e5e7eb !important;
  background-color: #f3f4f6 !important;
  color: #4b5563 !important;
  cursor: pointer !important;
  transition: all 0.15s ease !important;
  white-space: nowrap !important;
  gap: 6px !important;
  width: auto !important;
  height: 28px !important;
  min-height: 28px !important;
}

.selection-action-button:hover,
.dataset-action-button:hover {
  background-color: var(--primary-50, #edf2fa) !important;
  border-color: var(--primary-300, #7c9fd7) !important;
  color: var(--primary-700, #17356e) !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;
}

.selection-action-button:active,
.dataset-action-button:active {
  background-color: var(--primary-100, #d2dff0) !important;
}

.selection-action-button-danger {
  background-color: #fef2f2 !important;
  border-color: #fecaca !important;
  color: #dc2626 !important;
}

.selection-action-button-danger:hover {
  background-color: #fee2e2 !important;
  border-color: #fca5a5 !important;
  color: #b91c1c !important;
  box-shadow: 0 1px 3px 0 rgba(220, 38, 38, 0.1) !important;
}

.selection-action-button-danger:active {
  background-color: #fecaca !important;
}

.is-loading {
    position: relative; 
    pointer-events: none; 
    cursor: wait; 
}

.is-loading::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7); 
    z-index: 10; 
    border-radius: 0.25rem; 
}

.is-loading::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 32px; 
    height: 32px;
    margin-top: -16px; 
    margin-left: -16px; 
    border: 4px solid #f3f3f3; 
    border-top: 4px solid #1e4591; 
    border-radius: 50%;
    animation: spin 1s linear infinite; 
    z-index: 11; 
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

</style>
